import React from 'react';
import { Row, Col, Input, Form, message } from 'antd';
import Select from 'components/Select';
import Switch from 'antd/es/switch';
import { FormMode } from 'hooks/useForm';

const EmployeeForm = ({ form, locationOptions, agencyOptions }) => {
  const handleSubmit = async (values) => {
    try {
      await form.onSubmit(values);
      
      if (form.mode === FormMode.edit) {
        message.success('Employee updated successfully!', 5);
      } else {
        message.success('Employee created successfully!', 5);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.Error ||
        (form.mode === FormMode.edit
          ? 'Failed to update employee details.'
          : 'Failed to create a new employee.');

      message.error(errorMessage, 10);
    }
  };

return(
  <Form
    form={form}
    layout="vertical"
    hideRequiredMark={true}
    onFinish={handleSubmit}
  >
    <Row gutter={[12]}>
      <Col span={12}>
        <Form.Item
          label="Full Name"
          name="full_name"
          rules={[
            {
              required: true,
              message: 'Name is required',
            },
          ]}
        >
          <Input placeholder="Enter full name" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Phone Number"
          name="phone"
        >
          <Input placeholder="Enter Phone Number" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Location"
          name="location_id"
          rules={[
            {
              required: true,
              message: 'Location is required'
            }
          ]}
        >
          <Select options={locationOptions} placeholder="Select Location" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Agency"
          name="agency_id"
          rules={[
            {
              required: true,
              message: 'Agency is required'
            }
          ]}
        >
          <Select options={agencyOptions} placeholder="Select Agency" />
        </Form.Item>
      </Col>
    </Row>

    {form.mode === FormMode.edit ? (
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Code"
            name="code"
            >
            <Input placeholder="Enter code" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Tag" name="tag">
            <Input placeholder="Enter Tag" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Active"
            name="is_active"
            valuePropName="checked"
            normalize={(checked) => (checked ? 1 : 0)}
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
    ) : null}

    <Form.Item
      label="Notes"
      name="notes"
    >
      <Input.TextArea rows={3} placeholder="Notes" />
    </Form.Item>

  </Form>
  );
}
export default EmployeeForm;